import * as lobbyMessageTypes from './lobbyMessageTypes';


const initialState = {
 caseYearLobbyMessage:[],
 getLanguageList:[],
 getCountryandServiceList:[],
 getProductList:[],
 getLobbyMessage:''
};

const lobbyMessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case lobbyMessageTypes.GET_CASE_YEAR_LOBBYMESSAGE:
      return { ...state, caseYearLobbyMessage: action.payload.messages };
    case lobbyMessageTypes.GET_LANGUAGE_LOBBYMESSAGE:
      return { ...state, getLanguageList: action.payload.languages};
    case lobbyMessageTypes.GET_COUNTRY_SERVICE_LIST:
        return { ...state, getCountryandServiceList: action.payload.messages};
    case lobbyMessageTypes.GET_PRODUCT_TYPE:
      return { ...state, getProductList:action.payload.messages
      };   
    case lobbyMessageTypes.GET_LOBBYMESSAGE_By_PRODUCTTYPE_AND_LANGUAGE:
      return { ...state, getLobbyMessage:action.payload.messages
      };     
    case lobbyMessageTypes.RESET_LOBBY_MESSAGE_LIST:
    return { ...state, ...initialState
    };       
    default:
      return state;
  }
};

export { initialState };
export default lobbyMessageReducer;
